import React from "react";
import object from "./hotel_list.json";
import "./ListHotels.css";
import { Link } from "react-router-dom";

const ListHotels = () => {
  return (
    <div className="ListHotels-container">
      <h2 className="text-listhotels">Homes guests love</h2>
      <div className="list-hotels">
        {object.map((hotel, index) => (
          <div className="listhotel-card" key={index}>
            <img
              src={hotel.image_url}
              className="img-hotel"
              alt={hotel.name}
            ></img>
            {/* <h3 className="hotel-name">{hotel.name}</h3> */}
            <Link to={"/detail"} className="hotel-name">
              {hotel.name}
            </Link>
            <p className="city-hotel">{hotel.city}</p>
            <p className="price-hotel">Starting from {hotel.price}</p>
            <div className="rate-hotel">
              <p className="rate-number">{hotel.rate}</p>
              <p className="rate-text">{hotel.type}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListHotels;
